
import { Component, Input, Output  } from '@angular/core'; 
import { VehicleService } from '../_Services/vehicle.service';
import { CommonService } from '../_Services/common.service';
import { FormsModule, Validators, NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';  
import { NgxPaginationModule } from 'ngx-pagination';

@Component({
  templateUrl: 'broadcast.component.html'
})
export class BroadcastComponent {

    vehicles = [];  

    p: any = 1; 

    paginator = []; 
 

	constructor(private vehicleService: VehicleService, private route:ActivatedRoute) { }
 
	pageChanged(page: Number) {
		this.p = page; 
		this.vehicleService.getBroadcasts(page).subscribe(result => {
                console.log(result.paginator);
                this.vehicles = result.data;
                this.paginator = result.paginator; 
            });  
	}
	ngOnInit() {  
		this.vehicleService.getBroadcasts(this.p).subscribe(result => {
                console.log(result.data);
                this.vehicles = result.data;
                this.paginator = result.paginator; 
            });  
	}
}


// WEBPACK FOOTER //
// ./src/app/repoagencies/broadcast.component.ts